import { Update } from "@ngrx/entity";
import { createAction, props } from "@ngrx/store";

import * as fromModels from "../../models";

/** load notifications */
export const loadNotifications = createAction(
  "[Shared] [Notifications] load notifications",
  props<{ payload: { organizationId: string; query: fromModels.IQuery } }>()
);
export const loadNotificationsSuccess = createAction(
  "[Shared] [Notifications] load notifications success",
  props<{ payload: fromModels.IPagination }>()
);
export const loadNotificationsFailure = createAction(
  "[Shared] [Notifications] load notifications failure",
  props<{ payload: IError }>()
);

/** update notification */
export const updateNotification = createAction(
  "[Shared] [Notifications] update notification",
  props<{ payload: { organizationId: string; notificationId: string } }>()
);
export const updateNotificationSuccess = createAction(
  "[Shared] [Notifications] update notification success",
  props<{ payload: Update<fromModels.INotification> }>()
);
export const updateNotificationFailure = createAction(
  "[Shared] [Notifications] update notification failure",
  props<{ payload: IError }>()
);

/** update notifications */
export const updateNotifications = createAction(
  "[Shared] [Notifications] update notifications",
  props<{ payload: { organizationId: string } }>()
);
export const updateNotificationsSuccess = createAction(
  "[Shared] [Notifications] update notifications success"
);
export const updateNotificationsFailure = createAction(
  "[Shared] [Notifications] update notifications failure",
  props<{ payload: IError }>()
);
